import React, { Fragment } from 'react';
import { LeftMenuUser } from '../LeftMenuUser';
import { CurrentUserLimits } from '../../../../slices/current-user/current-user.state';
import { VenueId } from '../../../../venues/venues.types';
import { FeatureFlag } from '../../../../containers/FeatureFlags/FeatureFlag';
import { FeatureFlagsEnum } from '../../../../containers/FeatureFlags/FeatureFlags.enum';
import { HomeMenuItem } from '../items/HomeMenuItem';
import { MyAccountMenuItem } from '../items/MyAccountMenuItem';
import { NotificationSettingsMenuItem } from '../items/NotificationSettingsMenuItem';
import { MarketplaceDashboardMenuItem } from '../items/MarketplaceDashboardMenuItem';
import { MarketplaceTeamMembersMenuItem } from '../items/MarketplaceTeamMembersMenuItem';
import { useSelectedVenueId } from '../../../../slices/venue/use-selected-venue';
import { isVisibleInVenue } from '../../../../slices/venue/venue-menu-filter';

const HEADING = 'app-sidebar__heading vertical-nav-menu';

export interface BuyerMenuProps {
    user: LeftMenuUser;
    limits: CurrentUserLimits;
}

export const BuyerMenu = (props: BuyerMenuProps) => {
    const selectedVenue = useSelectedVenueId();

    return (
        <Fragment>
            <div id="left-menu" />
            <div>
                {!isVisibleInVenue([VenueId.Connect], selectedVenue) && (
                    <HomeMenuItem className={HEADING} />
                )}
                <MyAccountMenuItem />
                <FeatureFlag flag={FeatureFlagsEnum.FF_Notifications}>
                    <NotificationSettingsMenuItem />
                </FeatureFlag>
                {isVisibleInVenue([VenueId.Connect], selectedVenue) && (
                    <MarketplaceDashboardMenuItem />
                )}
                {isVisibleInVenue([VenueId.Connect], selectedVenue) && (
                    <MarketplaceTeamMembersMenuItem />
                )}
            </div>
        </Fragment>
    );
};
